module.exports = __webpack_public_path__ + "img/image01.8b7a2531.jpg";